export default __webpack_public_path__ + "static/media/beraksi-phone7.380e20b0.png";